'use strict';
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dFirst$002dName$002dForm$0024 from "./app.data.-User-Details$package$-User-First-Name-Form$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dLast$002dName$002dForm$0024 from "./app.data.-User-Details$package$-User-Last-Name-Form$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dMiddle$002dName$002dForm$0024 from "./app.data.-User-Details$package$-User-Middle-Name-Form$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$002dForm from "./app.data.-User-Details-Form.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserDetails$$anon$1() {
}
export { $c_Lapp_data_UserDetails$$anon$1 as $c_Lapp_data_UserDetails$$anon$1 };
$p = $c_Lapp_data_UserDetails$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_UserDetails$$anon$1;
/** @constructor */
function $h_Lapp_data_UserDetails$$anon$1() {
}
export { $h_Lapp_data_UserDetails$$anon$1 as $h_Lapp_data_UserDetails$$anon$1 };
$h_Lapp_data_UserDetails$$anon$1.prototype = $p;
$p.bwS = (function(src) {
  return new $j_app$002edata$002e$002dUser$002dDetails$002dForm.$c_Lapp_data_UserDetailsForm($j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dFirst$002dName$002dForm$0024.$m_Lapp_data_UserDetails$package$UserFirstNameForm$().aG().ak(src.z4), $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dMiddle$002dName$002dForm$0024.$m_Lapp_data_UserDetails$package$UserMiddleNameForm$().aG().ak(src.z6), $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dLast$002dName$002dForm$0024.$m_Lapp_data_UserDetails$package$UserLastNameForm$().aG().ak(src.z5));
});
$p.ak = (function(src) {
  return this.bwS(src);
});
var $d_Lapp_data_UserDetails$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserDetails$$anon$1, "app.data.UserDetails$$anon$1", ({
  F8: 1,
  V: 1,
  U: 1
}));
export { $d_Lapp_data_UserDetails$$anon$1 as $d_Lapp_data_UserDetails$$anon$1 };
//# sourceMappingURL=app.data.-User-Details$$anon$1.js.map
